import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'shared-ui-delete-button',
  imports: [NgClass],
  templateUrl: './delete-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteButtonComponent {
  readonly disabled = input(false);

  readonly clicked = output();
}
